import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const TeacherSlide12Tools: React.FC = () => {
  const features = [
    {
      category: 'Progress Monitoring',
      items: [
        'Real-time student mastery tracking',
        'Class-wide performance overview',
        'Individual student deep-dives',
        'Intervention alerts for struggling students',
      ],
    },
    {
      category: 'Assessment & Feedback',
      items: [
        'Instant automated marking',
        'Detailed error analysis',
        'Formative assessment tools',
        'Progress reports generation',
      ],
    },
    {
      category: 'Curriculum Alignment',
      items: [
        'Australian curriculum mapped',
        'Cross-curricular connections visible',
        'Prerequisite tracking',
        'Learning outcome coverage',
      ],
    },
    {
      category: 'Lesson Management',
      items: [
        'Assign content to students or classes',
        'Set learning goals and targets',
        'Track completion and engagement',
        'Customise learning pathways',
      ],
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-3 text-center"
      >
        Comprehensive Teacher <span className="text-[#0ea5e9]">Tools</span>
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl text-[#94a3b8] mb-10 text-center"
      >
        Everything you need to run an efficient, data-driven classroom
      </motion.p>

      <div className="grid grid-cols-2 gap-6 w-full max-w-5xl">
        {features.map((feature, index) => (
          <motion.div
            key={feature.category}
            initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 + index * 0.1 }}
            className="p-6 rounded-xl"
            style={{
              background: 'rgba(30, 41, 59, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }}
          >
            <h3 className="text-xl font-bold text-white mb-4">{feature.category}</h3>
            <div className="space-y-3">
              {feature.items.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <CheckCircleIcon className="w-5 h-5 text-[#10b981] flex-shrink-0 mt-0.5" />
                  <span className="text-[#94a3b8]">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TeacherSlide12Tools;
